import { ChangeDetectorRef, Injectable, OnInit } from "@angular/core";
import { DestroyBase } from "../components/common/ng-destroy-base";
import { EventBusService } from "../services/event-bus.service";

/**
 * Navigation base class
 */
@Injectable()
export class NavigationBase extends DestroyBase implements OnInit {
  /**
   * Indicates if the short navigation should be displayed
   */
  displayShortNavigation = false;

  /**
   * Constructor
   * @param ref ChangeDetectorRef
   */
  constructor(protected eventBus: EventBusService, private ref: ChangeDetectorRef) {
    super();
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.handleSidebarIcons();
  }

  /**
   * Handle sidebar icons and navigation display
   */
  handleSidebarIcons(): void {
    this.onEvents.push(this.eventBus.subscribeEvent('triggerShortNavigation', () => {
      this.displayShortNavigation = true;
      this.ref.markForCheck();
    }));
    this.onEvents.push(this.eventBus.subscribeEvent('resetShortNavigation', () => {
      this.displayShortNavigation = false;
      this.ref.markForCheck();
      this.eventBus.broadcastEvent('afterResetShortNavigation');
    }));
    this.onEvents.push(this.eventBus.subscribeEvent('displayFullNavigation', () => {
      this.displayFullNavigation();
      this.ref.markForCheck();
    }));
  }

  /**
   * Forces the full navigation to be displayed
   */
  public displayFullNavigation(): void {
    this.displayShortNavigation = false;
    this.eventBus.broadcastEvent('afterResetShortNavigation');
    this.eventBus.broadcastEvent('backClickedTrue');
    this.eventBus.broadcastEvent('showSaveCancelNavigationAction', false);//Bug 13227 Details Actions not removed (Might need a different fix in the future)
  }
}
